// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2608":"css/app.6952","6850":"css/admin-app.6952"}[chunkId] + ".css";
};